import React from 'react';
import { DashboardItemContainer } from '../../styles';
import { IBilledByMonthState } from '../../../../store/ducks/dashboard/types';
import BilledByMonthChart from './BilledByMonthChart';
import { Title } from '@gerdau/hefesto/Title';

interface IBilledByMonthProps {
  billedByMonthState: IBilledByMonthState;
  errorMessageBlock: React.ReactNode;
}

const BilledByMonth: React.FC<IBilledByMonthProps> = ({
  billedByMonthState,
  errorMessageBlock,
  children
}) => {
  return (
    <DashboardItemContainer className="squared billed-volume">
      <Title level={4}>Volume faturado (t)</Title>

      {billedByMonthState.error && !billedByMonthState.loading && (
        <>{errorMessageBlock}</>
      )}

      {billedByMonthState.loading && !billedByMonthState.error && (
        <>{children}</>
      )}

      {!billedByMonthState.error && !billedByMonthState.loading && (
        <BilledByMonthChart
          billedByMonthState={billedByMonthState}
          isEmpty={billedByMonthState.data.length === 0}
        />
      )}
    </DashboardItemContainer>
  );
};

export default BilledByMonth;
